import { FC } from 'react';

import { PageMetadata } from '@/shared/components/metadata';

const Metadata: FC = () => <PageMetadata description='Countercyclical is currently offline.' segments={['Offline']} />;

export default Metadata;
